import { Card, Header, Icon } from 'semantic-ui-react';

import { useAppContext } from '../../Contexts/AppContext';

export default function SelectItem(props) {
    const { Actions } = useAppContext();

    function onSelectComponent() {
        Actions.setTabStatus(props.nextTabStatus);
    }

    return (
        <Card onClick={onSelectComponent}>
            <Card.Content className='padding-vertical-20'>
                <Header as='h2' icon>
                    <Icon name={props.icon} />
                    {props.header}
                    <Header.Subheader>
                        {props.subheader}
                    </Header.Subheader>
                </Header>
                {/* TODO: The CSS written for this label should be deleted along with it. */}
                {props.header == 'Protection Plan' ?
                    <p className='select-item-title'>
                        Under Preparation
                    </p>
                    : null
                }
            </Card.Content>
        </Card>
    );
}
